'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _content = require('../actions/content');

var Actions = _interopRequireWildcard(_content);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var httpRequestStart = function httpRequestStart(state, isFetching) {
    return _extends({}, state, {
        isFetching: isFetching
    });
};

var httpRequestFailure = function httpRequestFailure(state, error, call) {
    return _extends({}, state, {
        isFetching: 0,
        error: {
            isError: true,
            errorCode: error && error.status ? error.status : null,
            errorMessage: error && error.message ? error.message : null,
            dataCall: call
        }
    });
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { content: [], isFetching: 0 };
    var action = arguments[1];

    switch (action.type) {
        // ------------------------------------------------------------------ READ CALLS ------------------------------------------------------------------

        case Actions.GET_ONE_CONTENT_START:
            {
                return httpRequestStart(state, state.isFetching + 1);
            }

        case Actions.GET_ONE_CONTENT_COMPLETE:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching - 1,
                    content: action.content
                });
            }

        case Actions.GET_ONE_CONTENT_FAILURE:
            {
                return httpRequestFailure(state, action.error);
            }

        case Actions.GET_CONTENT_ATTRIBUTE_START:
            {
                return httpRequestStart(state, state.isFetching + 1);
            }

        case Actions.GET_CONTENT_ATTRIBUTE_COMPLETE:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching - 1,
                    attributes: action.content
                });
            }

        case Actions.GET_CONTENT_ATTRIBUTE_FAILURE:
            {
                return httpRequestFailure(state, action.error, action.dataCall);
            }

        // ------------------------------------------------------------------ CREATE CALLS ------------------------------------------------------------------

        case Actions.WN_CREATE_THUMBNAIL_START:
            {
                return httpRequestStart(state);
            }

        case Actions.WN_CREATE_THUMBNAIL_COMPLETE:
            {
                var updatedThumbnailContents = state.content.filter(function (obj) {
                    if (obj.id === action.contentId) {
                        obj.thumbnail = action.content;
                    }
                    return obj;
                });
                return _extends({}, state, {
                    isFetching: 0,
                    content: updatedThumbnailContents
                });
            }
        case Actions.WN_CREATE_THUMBNAIL_FAILURE:
            {
                return httpRequestFailure(state, action.error, action.dataCall);
            }

        case Actions.REGISTER_FOR_CONTENT_START:
            {
                return _extends({}, state, {
                    registrationInfo: null,
                    isFetching: state.isFetching + 1
                });
            }

        case Actions.REGISTER_FOR_CONTENT_COMPLETE:
            {
                var registrationInfo = action.registrationInfo;
                return _extends({}, state, {
                    registrationInfo: registrationInfo,
                    isFetching: state.isFetching - 1
                });
            }

        case Actions.REGISTER_FOR_CONTENT_FAILURE:
            {
                return httpRequestFailure(state, action.err, action.dataCall);
            }
        // ------------------------------------------------------------------ UPDATE CALLS ------------------------------------------------------------------

        case Actions.PUT_CONTENT_ATTRIBUTE_START:
            {
                return httpRequestStart(state);
            }

        case Actions.PUT_CONTENT_ATTRIBUTE_COMPLETE:
            {
                return _extends({}, state, {
                    isFetching: 0,
                    attributes: action.attributes
                });
            }

        case Actions.PUT_CONTENT_ATTRIBUTE_FAILURE:
            {
                return httpRequestFailure(state, action.error, action.dataCall);
            }

        case Actions.WN_UPDATE_RECORDING_TITLE_START:
            {
                return httpRequestStart(state);
            }

        case Actions.WN_UPDATE_RECORDING_TITLE_COMPLETE:
            {
                var updatedTitleContents = state.content.map(function (obj) {
                    if (obj.id === action.contentId) {
                        obj.title = action.content.title;
                    }
                    return obj;
                });
                return _extends({}, state, {
                    isFetching: 0,
                    content: updatedTitleContents
                });
            }

        case Actions.WN_UPDATE_RECORDING_TITLE_FAILURE:
            {
                return httpRequestFailure(state, action.error, action.dataCall);
            }

        case Actions.WN_CREATE_CATEGORY_START:
            {
                return httpRequestStart(state);
            }

        case Actions.WN_CREATE_CATEGORY_COMPLETE:
            {
                var updatedContents = state.content.filter(function (obj) {
                    return obj.id !== action.content.id;
                });
                return _extends({}, state, {
                    isFetching: 0,
                    content: [action.content].concat(updatedContents)
                });
            }

        case Actions.WN_CREATE_CATEGORY_FAILURE:
            {
                return httpRequestFailure(state, action.error, action.dataCall);
            }

        // ------------------------------------------------------------------ DELETE CALLS ------------------------------------------------------------------
        case Actions.WN_DELETE_THUMBNAIL_START:
            {
                return httpRequestStart(state);
            }

        case Actions.WN_DELETE_THUMBNAIL_COMPLETE:
            {
                var _updatedThumbnailContents = state.content.filter(function (obj) {
                    if (obj.id === action.contentId) {
                        obj.thumbnail = null;
                        obj.defaultThumbnail = null;
                    }
                    return obj;
                });
                return _extends({}, state, {
                    isFetching: 0,
                    content: _updatedThumbnailContents
                });
            }

        case Actions.WN_DELETE_THUMBNAIL_FAILURE:
            {
                return httpRequestFailure(state, action.error, action.dataCall);
            }

        // ------------------------------------------------------------------ ERROR HANDLED CALLS ------------------------------------------------------------------
        case Actions.WN_CONTENTS_ERROR_HANDLED:
            {
                return _extends({}, state, {
                    error: {
                        isError: false,
                        errorCode: null,
                        errorMessage: null,
                        dataCall: null
                    }
                });
            }

        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/content.js
// module id = 783
// module chunks = 0